import { z } from "zod";
import { zDcChargingCurve, zVehicleModelCommonSchema, } from "./vehicleModel.common";
import { ConnectorType } from "../connector";
import { VehicleType } from "./vehicleModel.common";
// Доменная схема для VehicleModel
export const zVehicleModelSchemaDom = zVehicleModelCommonSchema
    .omit({
    usable_battery_size: true,
    dc_ports: true,
    vehicle_type: true,
    release_year: true,
    release_month: true,
    dc_max_power: true,
    dc_charging_curve: true,
    dc_is_default_charging_curve: true,
    manufacturer_id: true,
})
    .extend({
    usableBatterySize: z.number(),
    dcPorts: z.array(z.enum(ConnectorType)),
    vehicleType: z.enum(VehicleType),
    releaseYear: z.number().nullish(),
    releaseMonth: z.number().nullish(),
    dcMaxPower: z.number(),
    dcChargingCurve: z.array(zDcChargingCurve),
    dcIsDefaultChargingCurve: z.boolean(),
    manufacturerId: z.string().nullish(),
});
export const zVehicleModelSchemaCreateDom = zVehicleModelSchemaDom.omit({
    id: true,
});
export const zVehicleModelSearchViewSchema = zVehicleModelSchemaDom.extend({
    manufacturerName: z.string().nullish(),
});
